import { createFileRoute } from '@tanstack/react-router'
import { PatientEditorPage } from '@/features/patients/editor'

export const Route = createFileRoute('/patients_/new')({
  component: PatientEditorPage,
})
